import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "modals" }

import { storeToRefs } from 'pinia';
import { useModal } from '@/store';
import { ModalItem } from '@/services/types';
import ErrorMsg from '@ui/components/Modal/ErrorMsg.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEntry',
  setup(__props) {

const modals: Record<string, any> = {
  ErrorMsg,
};

const modalStore = useModal();
const { modalStack } = storeToRefs(modalStore);

const activeModal = (modal: ModalItem, i: number) => {
  const active = i + 1 === modalStack.value.length;
  if (active) return true;
  return modal.keepAlive;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modals" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(_TransitionGroup, { name: "modal" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modalStack), (modal, i) => {
              return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(modals[modal.name]), {
                key: `modal-${modal.id}`
              })), [
                [_vShow, activeModal(modal, i)]
              ])
            }), 128))
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, _unref(modalStack).length > 0]
      ])
    ]),
    _: 1
  }))
}
}

})